import React, { useState } from "react";
import CONSTANTS from "../../../utils/constants"
import { useEntityState, useSelectedEntity, useDynamicRequirementsFieldValue } from "../../../stores/entity/entity.hooks";
import { getFormDataValuesObjectForDraftApi } from "../../custom/forms/form-helper-methods";
import { useDispatch } from "react-redux";
import { verifyEntityInformation, saveEntityInformation } from "../../../stores/async/async-actions";
import { useParams } from "react-router-dom";
import { setVerifyEntityInformationOpen } from "../../../stores/entity/entity-action";
import { updateEntityDraft } from '../../../services/fenergo-service';
import { useForm } from "react-hook-form";
import { getFormInitialValuesFromEntityResponse, containJurisdiction } from "../../custom/forms/form-helper-methods";
import { FormData } from "../../custom/forms/form-data";
import NavButton from "../../portico/button/button";
import Spacing from "../../portico/spacing/spacing";
import CustomLoading from "../../custom/custom-loading";

interface DataPolicyCompanyDetailsProps {
  readOnly: boolean;
  journeyId: string;
  entityDraft: any;
  currentTask: object;
  completeTask: Function;
  journeyName?: string;
}

export const DataPolicyCompanyDetails: React.FC<DataPolicyCompanyDetailsProps> = ({
  readOnly, journeyId, journeyName, entityDraft, currentTask, completeTask
}) => {
  const dispatch = useDispatch();
  const { taskId } = useParams<{
    taskId: string;
  }>();
  const {
    verifyingEntityInformation,
  } = useEntityState();
  const selectedEntity = useSelectedEntity();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [showButton, setshowButton] = useState<boolean>(false);
  const formMethods = useForm({ defaultValues: getFormInitialValuesFromEntityResponse(entityDraft), mode: "onBlur" });
  const entityIdvRequiredValue = useDynamicRequirementsFieldValue('entityIdvRequired') || CONSTANTS.TRUE;
  const entityIdvRequired = entityIdvRequiredValue === CONSTANTS.TRUE;

  const isUKJurisdiction = containJurisdiction(entityDraft, "United Kingdom")
  const onVerifyClicked = async (values) => {
    var formData = getFormDataValuesObjectForDraftApi(CONSTANTS.CLIENT, values, entityDraft.jurisdictions, CONSTANTS.COMPANY, currentTask['businessCategory']);
    if (entityIdvRequired) {
      if (isUKJurisdiction) {
        setSubmitting(true);
        await dispatch(verifyEntityInformation(selectedEntity.id, entityDraft.id, { data: formData }, journeyId, isUKJurisdiction));
        setSubmitting(false);
        dispatch(setVerifyEntityInformationOpen(true));
      } else {
        dispatch(setVerifyEntityInformationOpen(true));
        dispatch(verifyEntityInformation(selectedEntity.id, entityDraft.id, { data: formData }, journeyId, isUKJurisdiction));
      }
      return;
    }

    setSubmitting(true);
    await updateEntityDraft(selectedEntity.id, entityDraft.id, { data: formData });
    await completeTask();
    setSubmitting(false);
  };

  const onIdentityVerifiedSave = async () => {
    cancelIdentityVerificationModal();
    await completeTask();
  }

  const cancelIdentityVerificationModal = () => {
    dispatch(setVerifyEntityInformationOpen(false));
  }

  const onDocumentsUploaded = async () => {
    dispatch(setVerifyEntityInformationOpen(false));
    await completeTask();
  }

  return (
    <>
      {submitting && <CustomLoading message="Saving Data..." />}
      <form data-testid="data-policy-form"
        onSubmit={formMethods.handleSubmit(onVerifyClicked)}
      >
        {currentTask && entityDraft && (
          <FormData
            key={currentTask["id"]}
            initialValues={getFormInitialValuesFromEntityResponse(entityDraft)}
            journeyId={journeyId}
            journeyName={journeyName}
            currentTaskName={currentTask["name"]}
            entityDraft={entityDraft}
            entityType={entityDraft["type"]}
            policyType={currentTask["policyRequirementType"]}
            categories={currentTask["businessCategory"]}
            targetEntity={currentTask["policyTarget"]}
            readOnly={readOnly}
            enableButton={setshowButton}
            formMethods={formMethods}
          />
        )}

        <Spacing variable="spacing-base-x3" />
        {showButton && entityDraft && currentTask && (
          <NavButton dataCy='save-btn' buttonLabel={entityIdvRequired ? CONSTANTS.VERIFY_REGISTRATION : CONSTANTS.SAVE_CONTINUE} />
        )}

      </form>
    </>
  );
};